import React from 'react';
import SvgIcon, { IconProps, getColor } from './SvgIcon';

export default function ItalicIcon(props: IconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke={getColor(props.color)} strokeLinecap="round" strokeWidth="1.5" d="M12 4h7M8 20l8-16M5 20h7" />
    </SvgIcon>
  );
}
